const value = {
    completionTimeAndReward: 'Время прохождения и награда',
    completionTime: 'Время прохождения',
    completionTimeDescription:
      'Укажите примерное количество времени, которое сотрудник потратит на прохождение практических заданий. Это помогает спланировать обучение.',
    awardDescription:
      'Общее количество баллов за юнит — 100. За каждое пройденное задание сотрудник может получить 25 баллов. Итоговый результат зависит от количества заданий, на которые он или она ответили правильно.',
  };

export default value;
